import {
  useFeatureToggleConfig,
  useIsChecklistAdminQuery,
} from '@infield/features/app-config';
import { useSelectedRootLocationConfiguration } from '@infield/features/app-config';
import { useIsLocationEnabledForFeatureFlag } from '@infield/features/feature-flags/location-toggles/use-is-location-enabled-for-feature-flag';
import { createContext, useContext } from 'react';

export interface IsSchedulerEnabledContextInterface {
  useSelectedRootLocationConfiguration: typeof useSelectedRootLocationConfiguration;
  useIsChecklistAdminQuery: typeof useIsChecklistAdminQuery;
  useFeatureToggleConfig: typeof useFeatureToggleConfig;
  useIsLocationEnabledForFeatureFlag: typeof useIsLocationEnabledForFeatureFlag;
}

export const IsSchedulerEnabledContext =
  createContext<IsSchedulerEnabledContextInterface>({
    useSelectedRootLocationConfiguration,
    useIsChecklistAdminQuery,
    useFeatureToggleConfig,
    useIsLocationEnabledForFeatureFlag,
  });

export const useIsSchedulerEnabledContext = () => {
  return useContext(IsSchedulerEnabledContext);
};
